import React from 'react'

import Checkbox from '../Fields/Checkbox'
import SingleInput from '../Fields/SingleInput'
import TextArea from '../Fields/TextArea'

import content from '../../assets/content/DentalImplant.json'
import classes from './layout.css'

const ModuleFour = (props) => {
	return (
		<div>
			<p>You have the right to be informed about your diagnosis and planned surgery so that you can decide whether to have a procedure or not after knowing the risks and benefits.</p>
			<ol>
				<li> 
					<Checkbox 
						controlFunc={props.addToForm}
						name={"cBox1"}
						id={"initial"}
						value={props.consentForm.cBox1.initial}
					/>My condition has been explained to me as a <strong>Missing Tooth or Missing Teeth</strong> described as:
					<TextArea
						name={"cBox1"}
						controlFunc={props.addToForm}
						inputType={"text"}
						id={"description"}
						value={props.consentForm.cBox1.description}
					/>
				</li>
				<li>
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox2"}
						id={"initial"}
						value={props.consentForm.cBox2.initial}
					/>
					The procedure proposed to treat this condition is <strong>Surgically Placing a Dental Implant or Implants</strong> into my jaw bones and gums in these positions
					<TextArea 
						controlFunc={props.addToForm}
						inputType={"text"}
						name={"cBox2"}
						id={"description"}
						value={props.consentForm.cBox2.description}
					/>
				</li>

				<li>
					<Checkbox 
						controlFunc={props.addToForm} 
						name={"cBox3"}
						id={"initial"}	
						value={props.consentForm.cBox3.initial}
					/>I have been informed of possible alternate methods of treatment (if any) including:
					<TextArea
						controlFunc={props.addToForm}
						inputType={"text"}
						name={"cBox3"}
						id={"description"}
						value={props.consentForm.cBox3.description}
					/>
				</li>
				<p>I understand that these other forms of treatment or no treatment at all are choices. The risks of those choices have been presented to me.</p>
				<li> 
					<Checkbox 
						controlFunc={props.addToForm} 
						name={"cBox4"}
						value={props.consentForm.cBox4}
					/>My doctor has explained to me that there are risks and side effects of any surgical procedure. For this procedure, the main risks include:
					<ol type="A">
						{content.map((item, index) => {
							let itemNumber = index + 1
							let itemName = `cBox${itemNumber}`
							return (
								<li key={index}>
									<Checkbox 
										controlFunc={props.addToForm}
										name={"potentialRisks"}
										id={itemName}
										value={props.consentForm.potentialRisks[itemName]}
									/>{item}
								</li>
							)
						})}
						<li>
							<Checkbox
								controlFunc={props.addToForm}
								name={"cBox16"}
								id={'initial'}
								value={props.consentForm.cBox16.initial}
							/>Other: 
							<TextArea
								controlFunc={props.addToForm}
								inputType={"text"}
								name={"cBox16"}
								id={"description"}
								value={props.consentForm.cBox16.description}
							/>
						</li>
					</ol>
				</li>
				<li>
					<Checkbox 
						controlFunc={props.addToForm} 
						name={"cBox5"}
						id={"initial"}
						value={props.consentForm.cBox5.initial}
					/>
					I understand that cuts (incisions) will be made inside my mouth in the gums to put one or more dental implants into my jaw bone. The implants will be the support for one or more missing tooth replacements to hold a crown, cap, bridge, partial denture, complete denture or plate. The doctor has explained the procedure, and told me how many incisions will be made, where they will be, and what kind of implants will be used. If a crown, bridge or denture is to be attached to this implant(s), this will be done by my general dentist,
					<SingleInput 
						controlFunc={props.addToForm}
						name={"cBox5"}
						id={"description"}
						value={props.consentForm.cBox5.description}
					/>
					, and that office will bill me for this procedure.
				</li>
				<li>
					<Checkbox 
						controlFunc={props.addToForm} 
						name={"cBox6"}
						value={props.consentForm.cBox6}
					/>
					Sometimes dental implants remain covered by gum tissue during the initial healing period. If the implant is covered by gum tissue, it will have to be surgically uncovered before it can be restored by the dentist. Sometimes dental implants are left exposed through the gum tissue when placed. Gum tissue grafting or trimming may be necessary before or after restoration by the dentist.
				</li>
				<li>
					<Checkbox 
						controlFunc={props.addToForm} 
						name={"cBox7"}
						value={props.consentForm.cBox7}
					/>
					No one has promised how long the implants will last. I have been told that once the implant is put in, I need to follow through with the whole treatment plan and finish it in the time period that is set by my doctors. If this is not done, the implants may fail.
				</li>
				<li>
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox8"}
						value={props.consentForm.cBox8}
					/>
					If my doctor finds a different condition than expected and feels that a different surgery or more surgery needs to be done, I agree to have it done
				</li>
				<li>
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox9"}
						value={props.consentForm.cBox9}
					/>
					The anesthetic I have chosen for my surgery is:<br />
					<div className={classes.Anesthesia}>
						<Checkbox
							name={"cBox9AnesthesiaOptions"}
							id={"1"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox9AnesthesiaOptions[1]}
						/>Local Anesthesia<br />

						<Checkbox
							name={"cBox9AnesthesiaOptions"}
							id={"2"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox9AnesthesiaOptions[2]}
							
						/>Nitrous Oxide/Oxygen Analgesia with Local Anesthesia<br />

						<Checkbox
							name={"cBox9AnesthesiaOptions"}
							id={"3"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox9AnesthesiaOptions[3]}
						/>Oral Premedication with Local Anesthesia<br />

						<Checkbox
							name={"cBox9AnesthesiaOptions"}
							id={"4"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox9AnesthesiaOptions[4]}
						/>Intravenous Sedation with Local Anesthesia<br />

						<Checkbox
							name={"cBox9AnesthesiaOptions"}
							id={"5"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox9AnesthesiaOptions[5]}
						/>Deep Sedation with Local Anesthesia
					</div>
				</li>
				<li>
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox10"}
						value={props.consentForm.cBox10}
					/>
					<strong>ANESTHETIC RISKS </strong>include: pain, swelling, bruising, swelling or infection of the vein area where the anesthesia or sedation was given. This could last a long time or make it hard for you to use your arm. This might need special care. There might be numbness that lasts a long time and allergic reactions. You might have nausea and vomiting from the IV Sedation or General Anesthesia, but this doesn’t happen often. IV Sedation and General Anesthesia are serious medical procedures. They are safe, but the rare risks of heart irregularities, heart attack, stroke, brain damage or death are present.
				</li>
				<li>
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox11"}
						value={props.consentForm.cBox11}
					/>
					<strong><u>YOUR OBLIGATIONS FOR IV SEDATION OR DEEP SEDATION IS:</u></strong>
					<ol type="A">
						<li>Because anesthetic medications cause prolonged drowsiness, you MUST be accompanied by a responsible adult to drive you home and stay with you until you are sufficiently recovered to care for yourself. This may be up to 24 hours.</li>
						<li>During recovery time you should not drive, operate complicated machinery or devices, or make important decisions.</li>
						<li>You must have a completely empty stomach. <u>IT IS VITAL THAT YOU HAVE <strong>NOTHING</strong> TO EAT OR DRINK FOR <strong>EIGHT</strong> (8) HOURS PRIOR TO YOUR ANESTHETIC. <strong>TO DO OTHERWISE MAY BE LIFE-THREATENING!</strong></u></li>
						<li><strong>However</strong>, it is important to take any regular medications (high blood pressure, antibiotics, etc.) or any medications directed by us, <strong><u>with only a small sip of water.</u></strong></li>
					</ol>
				</li>
				<li>
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox12"}
						value={props.consentForm.cBox12}
					/>
					<strong>TOBACCO USE:</strong> I understand that tobacco use is extremely detrimental to the success of implant surgery. I agree to cease all use of tobacco use for 2-3 weeks prior to and after surgery, including the later uncovering procedure. I also agree to make a strong effort to give up tobacco use entirely. I understand that failure to comply with the above recommendations dramatically increases my risk of implant failure.
				</li>
			</ol>

		</div>
	)
}

export default ModuleFour


// WEBPACK FOOTER //
// ./src/components/Modules/4.js